import * as Sentry from '@sentry/react';
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { NotFoundPage } from '@/components/NotFoundPage.tsx';
import { staffConsoleUrl } from '@/lib/staffConsoleUrl.ts';

/*
 * Every address the app does not know, caught inside the signed-in shell so the
 * not-found page keeps the navigation around it and sits behind the session guard.
 * Old staff console addresses are passed on to the console; anything else is a broken link
 * we sent, so it reaches Sentry.
 */
export const Route = createFileRoute('/_app/$')({
  loader: ({ location, preload }) => {
    if (preload) throw notFound();

    const staffUrl = staffConsoleUrl(location.pathname, location.searchStr);
    if (staffUrl) throw redirect({ href: staffUrl, replace: true });

    Sentry.captureMessage(`Unknown app route: ${location.pathname}`, {
      level: 'warning',
      extra: { search: location.searchStr },
    });
    throw notFound();
  },
  notFoundComponent: NotFoundPage,
});
